<template>
  <v-dialog v-model="mostrar" max-width="500px" persistent>
    <v-card :loading="loading">
      <v-toolbar
        color="blue-grey darken-1"
        dark
        dense
        flat
        class="text-h5"
        height="60px"
      >
        Nuevo de/para
      </v-toolbar>

      <v-container style="margin-top: 10px">
        <v-row>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="de"
              label="De"
              outlined
              dense
              :error-messages="error.de"
              @input="validarDe()"
              @blur="validarDe()"
            />
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="para"
              label="Para"
              outlined
              dense
              :error-messages="error.para"
              @input="validarPara()"
              @blur="validarPara()"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="status"
              label="Status"
              outlined
              dense
              :error-messages="error.status"
              @input="validarStatus()"
              @blur="validarStatus()"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-menu
              v-model="fechaPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Fecha"
                  :value="fechaTexto"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha"
                locale="es"
                @change="fechaPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" style="padding-bottom: 1px">
            <v-text-field
              v-model="asunto"
              label="Asunto:"
              outlined
              dense
              :error-messages="error.asunto"
              @input="validarAsunto()"
              @blur="validarAsunto()"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- Nuevo file input -->
        <v-file-input
          style="padding-top: 20px"
          v-model="files"
          color="blue-grey darken-1"
          label="Documentos"
          multiple
          dense
          counter
          prepend-icon="mdi-paperclip"
          outlined
          :show-size="1000"
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="blue-grey darken-1"
              dark
              label
              small
            >
              {{ text }}
            </v-chip>
            <span
              v-else-if="index === 2"
              class="text-overline grey--text text--darken-3 mx-2"
            >
              +{{ files.length - 2 }} Archivo(s)
            </span>
          </template>
        </v-file-input>
        <!-- Nuevo file input -->
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="blue-grey darken-1"
          :disabled="loading"
          outlined
          small
          @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="blue-grey darken-1"
          :loading="loading"
          :class="{
            'disable-events':
              error.de.length > 0 || 
              de.length === 0 ||
              error.para.length > 0 ||
              para.length === 0 ||
              error.asunto.length > 0 ||
              asunto.length === 0 ||
              error.status.length > 0 ||
              status.length === 0 
          }"
          dark
          small
          @click="guardarDepara()"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {DateTime,Settings} from 'luxon';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { crearOficioDeparaService } from "./depara.service";

Settings.defaultLocale = 'es';

export default {
  name: "crearNuevoDepara",
  mixins: [validationMixin],
  props: ["mostrar"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
    fechaTexto() {
      return this.fecha
        ? this.fecha ? DateTime.fromFormat(this.fecha, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        : "";
    },
  },
  validations: {
    de: { required },
    para: { required },
    asunto: { required },
    status: { required },
  },
  data: () => ({
    loading: false,
    files: [],
    de: "",
    para: "",
    fecha: DateTime.now().setZone('America/Mazatlan').toFormat('yyyy-MM-dd'),
    fechaPicker: false,
    status: "",
    asunto: "",
    error: {
      de: [],
      para: [],
      asunto: [],
      status: [],
    },
  }),
  methods: {
    validarDe() {
      this.$v.de.$touch();
      const errors = [];
      if (this.$v.de.$dirty) {
        !this.$v.de.required && errors.push("Campo requerido.");
      }
      this.error.de = errors;
    },
    validarPara() {
      this.$v.para.$touch();
      const errors = [];
      if (this.$v.para.$dirty) {
        !this.$v.para.required && errors.push("Campo requerido.");
      }
      this.error.para = errors;
    },
    validarStatus() {
      this.$v.status.$touch();
      const errors = [];
      if (this.$v.status.$dirty) {
        !this.$v.status.required && errors.push("Campo requerido.");
      }
      this.error.status = errors;
    },
    validarAsunto() {
      this.$v.asunto.$touch();
      const errors = [];
      if (this.$v.asunto.$dirty) {
        !this.$v.asunto.required && errors.push("Campo requerido.");
      }
      this.error.asunto = errors;
    },
    async guardarDepara() {
      try {
        this.loading = true;

        const formData = new FormData();
        formData.append("de", this.de);
        formData.append("para", this.para);
        formData.append("fecha", this.fecha);
        formData.append("asunto", this.asunto);
        formData.append("status", this.status);

        if (this.files != 0) {
          this.files.forEach((file) => {
            formData.append("archivo", file);
          });
        }

        const serverResponse = await crearOficioDeparaService(formData);
        this.loading = false;
        if (!serverResponse.ok)
          this.$systemErrorMessage(serverResponse.mensaje);
        else {
          this.loading = false;
          this.$notify({
            group: "gral_notif",
            type: "success",
            duration: 1500,
            speed: 500,
            text: serverResponse.mensaje,
          });
          this.$emit("deparaGuardado", serverResponse.depara);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
  },
};
</script>

